<template>
  <div v-loading="showFlag">
    <!--  運送台帳選択画面（大連工場） -->
    <t-card>
      <div>
        <t-row class="marginBottom">
          <t-col :span="1">&nbsp;</t-col>
          <t-col :span="22">
            <!-- テーブル -->
            <div>
              <t-table
                ref="jpReceTransSelectForm"
                :data="jpReceTransSelectForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                @row-click="handleRowClick"
                @row-dblclick="dbRowClick"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
          <t-col :span="1">&nbsp;</t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
                class="right"
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getTransSelect } from "@/services/jpReceive";
import { getDialogContentHeight } from "@/utils/comFunction";
import { t } from "@/locales";
import { Modal, Message } from "@tellus/component";
import { setColumnWidth } from "@/utils/table";
import { DIALOG_LINE_HEIGHT, STR_EMPTY } from "@/utils/const";
export default {
  data() {
    return {
      //日本入荷一覧選択情報
      jpReceTransSelectForm: [
        {
          tbTransOrderNo: "", // 運送No
          tbTransMethod: "", // 輸送方式
          tbDepartureDateOnly: "", // 出発日,
          tbUserCode: "", //担当者
          tbDestination: "", //目的地
          tbRemarks: "", //備考
        },
      ],

      //最大高さ
      maxheight: 260,

      //テーブルの列
      columns: [
        // 運送No
        {
          prop: "tbTransOrderNo",
          label: t("resource.JP_RECEIVE.TRANSPORT_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        {
          // 輸送方式
          prop: "tbTransMethod",
          label: t("resource.JP_RECEIVE.TRANSPORT_METHOD"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 出発日
        {
          prop: "tbDepartureDateOnly",
          label: t("resource.JP_RECEIVE.DEPARTURE_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 担当者
        {
          prop: "tbUserCode",
          label: t("resource.JP_RECEIVE.CONNECTER_NAME"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 目的地
        {
          prop: "tbDestination",
          label: t("resource.JP_RECEIVE.DESTINATION"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 備考
        {
          prop: "tbRemarks",
          label: t("resource.JP_RECEIVE.REMARKS"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],

      //現在選択されているセル
      currentCell: null,

      data: null,
      showFlag: false,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },

  props: {
    obSupCode: {
      Type: Object,
    },
  },
  mounted() {
    this.init();

    //列幅に自動調整
    setColumnWidth(this.columns, this.jpReceTransSelectForm);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },
    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // 初期化
    init() {
      this.showFlag = true;
      //検索処理
      this.searchClick();
      //列幅に自動調整
      setColumnWidth(this.columns, this.jpReceTransSelectForm);
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      getTransSelect()
        .then((res) => {
          this.jpReceTransSelectForm = res.jpReceDetailInfoList;

          setColumnWidth(this.columns, this.jpReceTransSelectForm);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //确定ボタン
    confirmClick() {
      var result = STR_EMPTY;
      if (this.currentCell) {
        if (this.currentCell.tbTransNo) {
          result = this.currentCell.tbTransNo;
        }
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }
    },

    //行データのクリック処理
    handleRowClick(row) {
      this.currentCell = row;
    },

    dbRowClick(row) {
      var result = STR_EMPTY;
      if (row) {
        if (row.tbTransNo) {
          result = row.tbTransNo;
        }
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
  },
};
</script>
<style scoped>
</style>
